import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "处理结果：", -1)

import { onMounted, reactive } from 'vue'
import { useRoute, useRouter } from "vue-router";
import PickImage from "@/components/view/PickImage.vue";
import { finishTask } from '@/api/home';
import message from 'ant-design-vue/lib/message';
import { searchTrackInfo } from '@/api/order';
import { searchRuleList } from '@/api/setting_rule';

export default /*#__PURE__*/_defineComponent({
  __name: 't1110',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const data = reactive({
    spinning: false,
    toothCheck: [],
    handlingStrategy: '更换下一步',
    wearingCycle: '',
    currentStep: '',
    wearingDay: '',
    scanStep: '',
    dataSource: [],
    opinion:''
})
// const dataSource = reactive(
//     [
//         {
//             itemId: 47,
//             itemName: "矫治器不贴合",
//             itemValue: "否",
//             itemType: "隐形正畸",
//             toothList: [],
//         }
//     ]
// )

const columns = [
    {
        title: '分类',
        dataIndex: 'itemType',
        key: 'itemType',
    },
    {
        title: '病症',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: '排除牙齿',
        dataIndex: 'address',
        key: 'address',
    },
    {
        title: '牙位',
        dataIndex: 'toothList',
        key: 'toothList',
        width: 200
    },
    {
        title: '检出状态',
        dataIndex: 'itemValue',
        key: 'itemValue',
        width: 200
    },
]

const toothOption = [
    '11', '12', '13', '14', '15', '16',
    '17', '18', '21', '22', '23', '24',
    '25', '26', '27', '28', '31', '32',
    '33', '34', '35', '36', '37', '38',
    '41', '42', '43', '44', '45', '46',
    '47', '48'
]


onMounted(() => {
    searchTrackInfo(route.query.oralTrackOrderId).then((res: any) => {
        console.log(res);
        data.wearingCycle = res.wearingCycle,
            data.currentStep = res.currentStep,
            data.wearingDay = res.wearingDay,
            data.scanStep = res.scanStep
    })
    searchRuleList({
        "page": {
            "currPage": 1,
            "pageSize": 1000
        },
        "ruleOwner": route.query.patientId,
        "defaultStatus": 1,
    }).then((res: any) => {
        console.log(res);
        if (res) {
            data.dataSource = res.data[0].abnormalList
            data.dataSource.forEach((item:any) => {
                item.itemValue = '否';
                item.toothList = [];
                item.itemType = "隐形正畸";
            })
        }
    })
})

const handleChange = (value: string, item: any) => {
    item.itemValue = value.length > 0 ? '是' : '否'
};

const onSubmit = () => {
    data.spinning = true
    let oralDetectionResultItemList: any[] = [];
    data.dataSource.forEach((item: any) => {
        if (item.toothIndex instanceof Array) {
            item.toothIndex = item.toothIndex.join(',')
        }
        oralDetectionResultItemList.push({
            itemId: item.itemId,
            itemValue: item.itemValue ? item.itemValue : "否",
            toothIndex: item.toothIndex ? item.toothIndex : '',
        });
    });
    let option = {
        processDefinitionId: route.query.processDefinitionId,
        processDefinitionKey: route.query.processDefinitionKey,
        processInstanceId: route.query.processInstanceId,
        runTimeTaskId: route.query.runTimeTaskId,
        taskCode: route.query.taskCode,
        params: {
            result: data.handlingStrategy,
            oralDetectionOrderId: route.query.oralDetectionOrderId,
            oralDetectionResultItemList: oralDetectionResultItemList,
            opinion:data.opinion
        },
    };
    finishTask(option).then(() => {
        data.spinning = false
        message.success("操作成功");
        router.push({
            path: "/home",
        });
    }).catch(() => {
        data.spinning = false
    })
};



return (_ctx: any,_cache: any) => {
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_spin, {
      spinning: data.spinning
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_space, {
          size: 10,
          direction: "vertical"
        }, {
          default: _withCtx(() => [
            (_unref(route).query.oralDetectionOrderId != null)
              ? (_openBlock(), _createBlock(PickImage, {
                  key: 0,
                  oralDetectionOrderId: _unref(route).query.oralDetectionOrderId
                }, null, 8, ["oralDetectionOrderId"]))
              : _createCommentVNode("", true),
            _createVNode(_component_a_card, { title: "扫描前基本信息" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions, { size: "small" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_descriptions_item, { label: "佩戴周期" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(data.wearingCycle), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "当前佩戴步数" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(data.currentStep), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "扫描步数" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(data.scanStep), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_descriptions_item, { label: "已佩戴天数" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(data.wearingDay), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_card, { title: "出具分析结果" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_table, {
                  dataSource: data.dataSource,
                  columns: columns,
                  pagination: false
                }, {
                  bodyCell: _withCtx(({ column, record }) => [
                    (column.key === 'toothList')
                      ? (_openBlock(), _createBlock(_component_a_select, {
                          key: 0,
                          value: record.toothList,
                          "onUpdate:value": ($event: any) => ((record.toothList) = $event),
                          style: {"width":"200px"},
                          mode: "multiple",
                          options: toothOption.map(item => ({ value: item })),
                          onChange: (value) => handleChange(value, record)
                        }, null, 8, ["value", "onUpdate:value", "options", "onChange"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["dataSource"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_card, { title: "医生建议" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: data.opinion,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((data.opinion) = $event)),
                  placeholder: "医生建议",
                  rows: 4
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_card, null, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_a_radio_group, {
                  value: data.handlingStrategy,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((data.handlingStrategy) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_radio, { value: "更换下一步" }, {
                      default: _withCtx(() => [
                        _createTextVNode("更换下一步")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_radio, { value: "佩戴当前步" }, {
                      default: _withCtx(() => [
                        _createTextVNode("佩戴当前步")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, { onClick: onSubmit }, {
              default: _withCtx(() => [
                _createTextVNode("提交")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}
}

})